export default "__VITE_ASSET__CC3J36SB__"